import React from 'react';
import Link from 'next/link';
import Icon from '@components/common/assets';
import Colors from '@domain/constant/colors';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Interviewee = () => {
  return (
    <div className={cx('commonBox')}>
      {/* 타이틀 */}
      <div className={cx('basicTitleInner')}>
        <span className={cx('basicTitle')}>JOBDA matching으로 기업에게 입사 제안 받고</span>
        <span className={cx('subTitle')}>합격한 선배들의 Story를 확인해보세요.</span>
      </div>

      <span className={cx('titleInfo')}>* 이미지를 누르면 풀 스토리를 확인할 수 있어요.</span>

      {/* 인터뷰 리스트 */}
      <div className={cx('interviewList')}>
        <Link className={cx('interViewItem', 'item1')} href={'https://www.jobda.im/info/466'} target="_blank" />
        <Link className={cx('interViewItem', 'item2')} href={'https://www.jobda.im/info/422'} target="_blank" />
        <Link className={cx('interViewItem', 'item3')} href={'https://www.jobda.im/info/459'} target="_blank" />
        <Link className={cx('interViewItem', 'item4')} href={'https://www.jobda.im/info/395'} target="_blank" />
      </div>

      <Link className={cx('btnMatch')} href={RouteUrl.PASSBOARD} target="_blank">
        취업 합격후기 풀버전 확인하기
        <Icon name="arrowRightLight" width={32} height={32} fill={Colors.C_LIGHT_GREEN_100} />
      </Link>
    </div>
  );
};

export default Interviewee;
